import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnChanges, OnDestroy, OnInit, Renderer2 } from '@angular/core';
export type TTooltipPosition = 'left' | 'right' | 'bottom' | 'top' | 'top-right';
@Component({
    selector: 'tooltip',
    templateUrl: 'tooltip.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./tooltip.scss'],
    standalone: true
})
export class TooltipComponent implements OnInit, OnDestroy, OnChanges {
    @Input()
    position: TTooltipPosition = 'top';

    @HostBinding('class.light-mode')
    @Input()
    lightMode = false;
    /**
     * Class that has been applied already
     */
    private appliedClassName?: string;
    constructor(
        private elementRef: ElementRef<HTMLElement>,
        private renderer2: Renderer2
    ) {}
    ngOnInit(): void {
        this.renderer2.addClass(this.elementRef.nativeElement.parentElement, '_hasICmsTooltip');
    }
    ngOnDestroy(): void {
        const parent = this.elementRef.nativeElement.parentElement;
        if (parent) {
            this.renderer2.removeClass(parent, '_hasICmsTooltip');
        }
    }
    ngOnChanges(changes) {
        if (changes['position']) {
            const posClass = `_${this.position || 'top'}`;
            if (this.appliedClassName !== posClass) {
                if (this.appliedClassName) {
                    this.renderer2.removeClass(this.elementRef.nativeElement, this.appliedClassName);
                }
                this.appliedClassName = posClass;
                this.renderer2.addClass(this.elementRef.nativeElement, this.appliedClassName);
            }
        }
    }
}
